var map = {
	"./character/decor-character-mobile.png": 2815,
	"./character/decor-character.png": 3002,
	"./music/decor-music-mobile.png": 511,
	"./music/decor-music.png": 9402,
	"./prompt/decor-prompt-mobile.png": 8473,
	"./prompt/decor-prompt.png": 9552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5185;